import type { IEntityStats } from '../types/entity.types';
import { scaleMonsterStat } from './monsters.config';

export const LEVEL_CAP = 99;

/**
 * Cumulative XP curve per level.
 * Reference points: L1=0, L2=10, L5=100, L10=450, L20=1900, L50=12250,
 * L99=48510.
 */
export function xpCumulativeFor(level: number): number {
  return level * (level - 1) * 5;
}

/**
 * Passive per-level stat scaling. The persistent character level (1..LEVEL_CAP)
 * grows the player's core stats on the SAME linear curve and rates as monsters
 * (cf. DEFAULT_STAT_RATES in monsters.config), so the player keeps pace with the
 * floor's monsterLevel. Stats not listed here do not scale with level — they
 * come from trinkets / sketches / boss boosts / intra-run items.
 */
export const PLAYER_LEVEL_STAT_RATES: Partial<
  Record<keyof IEntityStats, number>
> = {
  maxLife: 0.12,
  physicalAttack: 0.08,
  magicAttack: 0.08,
  physicalDefense: 0.06,
  magicDefense: 0.06,
};

/** A player core stat scaled to `level` on the monster linear curve. */
export function playerStatAtLevel(
  base: number,
  level: number,
  rate: number,
): number {
  return scaleMonsterStat(base, level, rate, 'linear');
}
